(function () {
    "use strict";

    angular.module("app").controller("PersonDossierController", PersonDossierController);
    PersonDossierController.$inject = ["$scope", "$window", "dossierService", "controllerDecorator", "habilEnabledFeatures", "enumService",];
    function PersonDossierController($scope, $window, dossierService, controllerDecorator, habilEnabledFeatures, enumService) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments", "files"]);

        const ivmStatusCodes = enumService.IvmStatusCodes;

        function initializeFilters() {
            $scope.filterRelations = function (item) {
                return item.PersonTypeCode !== '10' &&
                    item.PersonTypeCode !== '11' &&
                    item.PersonTypeCode !== '20' &&
                    item.PersonTypeCode !== '21' &&
                    item.PersonTypeCode !== '120' &&
                    item.PersonTypeCode !== '121' &&
                    item.PersonTypeCode !== '170' &&
                    item.PersonTypeCode !== '171' &&
                    !item.IsPartner;
            };
            $scope.filterChildren = function (item) {
                return (item.PersonTypeCode === '21' ||
                    item.PersonTypeCode === '120' ||
                    item.PersonTypeCode === '121') &&
                    !item.IsPartner;
            };
            $scope.filterRefs = function (item) {
                return item.PersonTypeCode === '170';
            };
            $scope.filterPartners = function (item) {
                return item.IsPartner ||
                    item.PersonTypeCode === '10' ||
                    item.PersonTypeCode === '11' ||
                    item.PersonTypeCode === '20' ||
                    item.PersonTypeCode === '171';
            };
            $scope.filterAttachmentContainsExtract = (att) => att.TypeCode === '900';
        }

        $scope.AllScreenings = [];

        $scope.request = null;

        function initialize() {
            const parsed = vm.ParseUrl();
            $scope.dossierId = parsed.parameters.dossierid ?? $window.location.search.split("?")[1];

            initializeFilters();

            loadDossier();
        }

        $scope.isCurrent = (tab) => dossierService.currentTab === tab;

        $scope.$on("navigation_change", (_event, tab) => dossierService.currentTab = tab.key);

        function loadDossier() {
            vm.SetLoadingState(true);

            dossierService.searchPerson($scope.dossierId,
                function (result) {
                    if (CheckResultReceived(result)) {
                        $scope.dossier = result;

                        getLastDetailUrl();

                        dossierService.searchPersonOrganisation($scope.dossierId,
                            function (result) {
                                if (!CheckResultReceived(result)) {
                                    vm.ShowError(result);
                                    return;
                                }

                                $scope.Person = result;

                                vm.SetLoadingState(false);
                            },
                            function (result) {
                                vm.ShowError(result);
                                vm.SetLoadingState(false);
                            });
                    }
                    else { vm.ShowError(result); }
                },
                function (error) {
                    vm.ShowError(error);
                    vm.SetLoadingState(false);
                });
        }

        function getLastDetailUrl() {
            if ($scope.dossier && $scope.dossier.LastRequestId !== null) {
                $scope.requestId = $scope.dossier.LastRequestId;

                loadRequest();
            }
        }

        function loadRequest() {
            if (!$scope.requestId)
                return;

            vm.SetLoadingState(true);

            $scope.loadingIvm = true;

            vm.Api.GetIVMRequestPhase5(
                { RequestId: $scope.requestId },
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.request = result.data;

                        $scope.AllScreenings = [...$scope.request.Screenings, ...$scope.request.ForeignScreenings];

                        getRemarks();

                        prepareData();

                        vm.Comments.Initialize({ RequestId: $scope.request.PublicId, DossierId: null, OrganisationId: $scope.request.DossierOrganisationPublicId, ICD: $scope.request.ScreeningBy });
                    }
                    else { vm.ShowError(result); }
                },
                vm.ShowError,
                () => {
                    vm.SetLoadingState(false);

                    $scope.loadingIvm = false;
                }
            );
        };

        $scope.IsPersonReinvestigation = function (screening) {
            return screening.TypeCode == enumService.ScreeningTypeCode.PersonReinvestigation;
        };

        function getRemarks() {
            vm.Api.GetRemarksForPscRequest(
                { RequestId: $scope.request.PublicId },
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.otherRemarks = result.data.OtherRemarks;
                    }
                    else {
                        vm.ShowError(result);
                    }
                },
                vm.ShowError
            );
        }

        $scope.PersonsThatNeedToSign = personsThatNeedToSign;
        function personsThatNeedToSign() {
            if (!$scope.request || !$scope.request.RequestIVMRelatedPersonList)
                return [];

            return $scope.request.RequestIVMRelatedPersonList.filter(function (r) {
                return (r !== null && r.PersonData && r.PersonData.NeedsSigning) ? r : null;
            });
        }

        function prepareData() {
            // Needed Checks
            $scope.request.SelectedJusts = [];

            const states = [ivmStatusCodes.Accepted, ivmStatusCodes.AcceptedWithLimitation, ivmStatusCodes.Signed, ivmStatusCodes.SignedWithLimitation];

            if (states.includes($scope.request.Status)) {
                $scope.request.Limited = true;
            }

            vm.SetLoadingState(false);
        }

        $scope.IsPayrollConsultantFeatureEnabled = isPayrollConsultantFeatureEnabled;
        function isPayrollConsultantFeatureEnabled() {
            if (!$scope.request || $scope.request.CreatedByFVM)
                return false;

            const ivmPayrollConsultant = "IVM_PAYROLL_CONSULTANT";
            return habilEnabledFeatures.some(f => f == ivmPayrollConsultant);
        }

        $scope.GetScreeningReports = getScreeningReports;

        const cache = {
            screeningReports: null
        };

        function getScreeningReports() {
            if (Array.isArray(cache.screeningReports)) {
                return cache.screeningReports;
            }

            if (!$scope.request?.Screenings?.length) {
                return [];
            }

            cache.screeningReports = $scope.request.Screenings.flatMap(s => s.Attachments?.filter(a => a.TypeCode == enumService.AttachmentTypes.ScreeningResultDocument) ?? []);

            return cache.screeningReports;
        }

        $scope.getPscRequestRowStyle = getPscRequestRowStyle;
        function getPscRequestRowStyle(request) {
            if (!request)
                return;

            if (request.Deleted)
                return "bg-danger";

            const states = [
                enumService.IvmStatusCodes.ConfirmStopScreening,
                enumService.IvmStatusCodes.ConfirmationGivenToStopScreening
            ];

            if (states.includes(request.Status) && request.IsReported)
                return "retour";

            if (request.IsForeign)
                return "panel-Foreign bg-Foreign";
        }

        initialize();
    }
})();
